import React, { useState, useEffect, useMemo } from 'react';
import { useLocation, useHistory } from 'react-router-dom'
import Axios from 'axios';

const UserContext = React.createContext();

export function UserProvider(props) {
  const [login, setLogin] = useState(false);
  const [usuario, setUsuario] = useState(null);
  const [userId, setUserId] = useState(null);
  const [cargandoUsuario, setCargandoUsuario] = useState(true);
  const history = useHistory();


  function checkFBStatus() {
    let redirect = arguments.length == 1 ? arguments[0] : false;
    window.FB.getLoginStatus( response => {
      if( response.status === 'connected'){
          setData(response.authResponse, () => {
            if( redirect !== false ) {
              history.push(redirect);
            }
          });
      } else if (response.status === 'not_authorized') {
        setCargandoUsuario(false);
      } else {
        setCargandoUsuario(false);
      }

      //console.log(response)
    });
  }
  function logout(){

    window.FB.logout(function(response) {
      setUsuario(null);
    })
  }

  function FBLogin() {
    window.FB.login(response => {
      checkFBStatus('/mi-perfil');
      console.log(response);
    }, {scope: 'email,public_profile'})
    // }, {scope: 'public_profile, email, user_photos, user_gender, user_link'})
  }

  function setData( data, callback ) {
    console.log("Set Data Context")
    console.log(callback)
    console.log(data)
    if (data.accessToken) {
      setLogin(true);
      Axios.post(process.env.REACT_APP_API + '/api/v1/user/set', data )
           .then(function(response) {
             
             data.local_id      = response.data.id;
             data.profile_image = response.data.profile_image;
             data.first_name    = response.data.first_name;
             data.birthday      = response.data.birthday;
             data.edad          = typeof response.data.edad !== 'undefined' ? response.data.edad : null; 
             data.signo         = typeof response.data.signo !== 'undefined' ? response.data.signo : null; 
             data.location      = typeof response.data.location !== 'undefined' ? response.data.location : null; 
             data.likes         = typeof response.data.likes !== 'undefined' ? response.data.likes : []; 
             
             setUsuario(data) ;
             setUserId( data.local_id )
             setCargandoUsuario(false);
             setTimeout(callback, 100)
           })
           .catch(e => {
             setCargandoUsuario(false);
           })
    } else {
      setCargandoUsuario(false);
      setLogin(false);
    }
  }

  const value = {
    usuario,
    setUsuario,
    cargandoUsuario,
    setCargandoUsuario,
    logout,
    setData,
    login,
    setLogin,
    FBLogin,
    checkFBStatus
  }
  return <UserContext.Provider value={value} {...props} />
}

export function useUser() {
  const context = React.useContext(UserContext);
  if( ! context ) {
    throw new Error('useUser debe estar dentro del provider UserProvider');
  }
  return context;
}
